import axios from 'axios';
import {API} from "@/services/url";


export default {
	getEmployeeList: function (params, success, error) {
		axios.get(API.employee.all,{
			params : {
				email    : params.email,
				rfid     : params.rfid,
				officeId : params.officeId,
				isAdmin  : params.isAdmin,

			}
		})
			.then(r => success(r.data.employees) )
			.catch(e => error(e.response.data.message));
	},
	resetPassword: function (employeeId, success, error) {
		axios.post(API.employee.all+employeeId)
			.then( r => success(r))
			.catch(e => error(e.response.data.message))
	},
	cloneTemporaryAllocations: function (formData, success, error) {
		axios.post(API.customer.cloneTemporaryAllocations, formData)
			.then( r => success(r))
			.catch(e => error(e.response.data.message))
	},
	downloadArchivedReport: function (formData, fileName, success, error) {
		return axios.post(API.customer.downloadArchivedReport, formData, {
			responseType : "blob"
		})
			.then(r => success(r, fileName))
			.catch(e => error(e));
	},
}
